<script>
    import { createEventDispatcher } from 'svelte';
  
    export let items = [];

    export let displayProperty = 'title'
    export let idProperty = 'id'

    const dispatch = createEventDispatcher();
  
    let draggedItemIndex = null;
    let localItems = [];
  
    // Sync local items when props change
    $: {
      localItems = [...items];
    }
  
    function handleDragStart(event, index) {
      draggedItemIndex = index;
      event.dataTransfer.effectAllowed = 'move';
    }
  
    function handleDragOver(event, index) {
      event.preventDefault();
      if (draggedItemIndex === null) return;
      
      const targetIndex = index;
      if (draggedItemIndex !== targetIndex) {
        // Update local items immediately for responsive UI
        const newItems = [...localItems];
        const [movedItem] = newItems.splice(draggedItemIndex, 1);
        newItems.splice(targetIndex, 0, movedItem);
        localItems = newItems;
        
        // Update dragged item index
        draggedItemIndex = targetIndex;
        
        // Notify parent of change
        dispatch('orderChanged', { items: newItems });
      }
    }
  
    function handleDragEnd() {
      draggedItemIndex = null;
    }
  </script>
  
  <style>
    .list {
      list-style: none;
      padding: 0;
      margin: 0;
    }
  
    .item {
      padding: 12px;
      margin: 8px 0;
      background: #ffffff;
      border: 1px solid #e0e0e0;
      border-radius: 4px;
      cursor: move;
      transition: transform 0.2s ease, opacity 0.2s ease;
    }
  
    .item.dragging {
      opacity: 0.5;
      background: #f8f8f8;
    }
  
    .item:hover {
      transform: translateX(4px);
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  </style>
  
  <ul class="list">
    {#each localItems as item, index (item[idProperty])}
      <li
        class="item"
        class:dragging={index === draggedItemIndex}
        draggable="true"
        on:dragstart={(e) => handleDragStart(e, index)}
        on:dragover={(e) => handleDragOver(e, index)}
        on:dragend={handleDragEnd}
      >
        <slot name="item" item={item}>
        </slot>
      </li>
    {/each}
  </ul>